import { Box } from '@mui/material'
import { useStore } from '@priolo/jon'
import DateRangePickerH from 'components/controls/select/DateRangePickerH'
import SelectorCropsH from 'components/controls/select/SelectorCropsH'
import SelectorCycleH from 'components/controls/select/SelectorCycleH'
import SelectorGrowUnitH from 'components/controls/select/SelectorGrowUnitH'
import SelectorPhaseH from 'components/controls/select/SelectorPhaseH'
import SelectorTypeH from 'components/controls/select/SelectorTypeH'
import FilterLockButton from 'components/header/FilterLockButton'
import { FunctionComponent, useMemo } from 'react'
import cycleSo from "stores/cycle"
import querySo from 'stores/route/query'
import { queryFromNumberArray, queryToNumberArray } from 'stores/route/utils/query'
import { URL_PAR } from 'stores/route/utils/types'
import { Cycle } from 'types/Cycle'
import { GrowUnit } from 'types/GrowUnit'
import { DateRange, PhaseString } from 'types/global'
import { dateRangeToUrl, urlToDateRange } from 'utils'



interface Props {
}

const AttachmentFilterHeader: FunctionComponent<Props> = ({
}) => {

	// STORE
	const querySa = useStore(querySo)

	// HOOKs

	// HANDLERs
	const handleChangeDateRange = (dateRange: DateRange) => {
		querySo.setSearchUrl([URL_PAR.DATE_SEL, dateRangeToUrl(dateRange)])
	}
	const handleChangeGrowUnit = (growUnit: GrowUnit) => {
		querySo.setSearchUrl([URL_PAR.GROWUNIT_SEL, growUnit?.id?.toString()])
	}
	const handleChangeCrop = (cropIds: number[]) => {
		querySo.setSearchUrl([URL_PAR.CROP_SEL, cropIds?.length ? queryFromNumberArray(cropIds) : null])
	}
	const handleChangeCycle = (cycle: Cycle) => {
		querySo.setSearchUrl([URL_PAR.CYCLE_SEL, cycle?.cycleUuid])
	}
	const handleChangePhase = (phase: PhaseString) => {
		querySo.setSearchUrl([URL_PAR.PHASE_SEL, phase])
	}
	const handleChangeType = (type: string) => {
		querySo.setSearchUrl([URL_PAR.TYPE_SEL, type])
	}

	// RENDER
	const [growUnitId, cropIds, cycle, dateRangeSel, phase, type] = useMemo(() => {
		const [growUnitId, cropIdsUrl, cycleUuid, dateRangeSelUrl, phase, type] = querySo.getSearchUrl(
			[URL_PAR.GROWUNIT_SEL, URL_PAR.CROP_SEL, URL_PAR.CYCLE_SEL, URL_PAR.DATE_SEL, URL_PAR.PHASE_SEL, URL_PAR.TYPE_SEL]
		)
		let dateRangeSel = urlToDateRange(dateRangeSelUrl)
		const cycle = cycleSo.getCycleByUuid(cycleUuid)
		const cropIds = queryToNumberArray(cropIdsUrl)
		return [growUnitId, cropIds, cycle, dateRangeSel, phase, type]
	}, [querySa.queryUrl])

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

			<FilterLockButton />

			<DateRangePickerH
				dateRange={dateRangeSel}
				onChange={handleChangeDateRange}
			/>

			<SelectorGrowUnitH
				growUnitId={+growUnitId}
				onChange={handleChangeGrowUnit}
			/>

			<SelectorCropsH
				cropIds={cropIds}
				onChange={handleChangeCrop}
			/>

			<SelectorCycleH
				cycle={cycle}
				onChange={handleChangeCycle}
			/>

			<SelectorPhaseH
				phase={phase}
				onChange={handleChangePhase}
			/>

			<SelectorTypeH
				type={type}
				onChange={handleChangeType}
			/>

		</Box >
	)
}

export default AttachmentFilterHeader

